// 对于不同页面体系的路由，需要管理不同的缓存策略

export const includesEnterprise = [
	'single_template_home_root',
	'single_template_home',
	'single_template_home_nine',
	'single_template_home_ebmedical',
	'single_component_frame',
	'single_component_frame_sub',
	'multi_template_home_root',
	'multi_template_home',
	'multi_component_frame',
	'multi_component_frame_sub'
];

export const enterpriseDepViews = [
	'irmIframe',
	'enterprise_preview',
	'areaCode_index',
	'attend_meeting_promise',
	'attend_meeting_sign',
	'investor_entourage'
];
